import { addBook } from "../actions"

function createId(data) {
    return data.reduce((pre, current) => Math.max(pre, current.id), -1) + 1

}
const addNewBookToServer = (data) => {
    return async (dispatch, getState) => {
        const state = getState()
        console.log(state)
        const response = await fetch("http://localhost:9000/books", {
            method: "POST",
            body: JSON.stringify({
                ...data,
                id: createId(state.books.books)
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
            },
        });
        const book = await response.json();
        dispatch(addBook(book))
    }
}
export default addNewBookToServer